import { API } from "@/lib/api";

const device = () => (window.innerWidth < 768 ? "mobile" : window.innerWidth < 1024 ? "tablet" : "desktop");

export function track(type, path, meta = {}) {
  const p = path || window.location.pathname;
  if (p.startsWith("/admin")) return;
  try {
    fetch(`${API}/analytics/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type, path: p, meta: { device: device(), ...meta } }),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {}
}
